// extracted by mini-css-extract-plugin
export default {"root":"t9zLjWuZI_JeWgG36miG","wrap":"FhCJJi3Qc53467czsLUk","main":"kGRO1BilS4aDy4q9Lon2","label":"toLL3x3LzTkZVuVOJvkg","input":"GYwxedD5qBsFMBKhJOmr"};